import { useTranslation } from 'react-i18next';

import { Heading } from '@app/shared/ui/atoms/Common';

export function Title() {
  const { t } = useTranslation();

  return (
    <Heading level={2} className="relative text-center">
      {t('user_data_form.title')}
    </Heading>
  );
}
